import { render, staticRenderFns } from "./ShippingRangeCreate.vue?vue&type=template&id=d84f8576&scoped=true&"
import script from "./ShippingRangeCreate.vue?vue&type=script&lang=js&"
export * from "./ShippingRangeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84f8576",
  null
  
)

export default component.exports